<div class="py-2 pt-md-0 pb-md-4 contract-item-container" data-e2e="contracts-options">
  @if (getIcon()) {
  <div>
    <img alt="" [src]="getIcon()" />
  </div>
  }
  <div class="row">
    <div class="col-12 col-md-6 col-lg-5">
      <h3 class="mb-0">{{protectedHouseContractViewModel?.offerName}}</h3>
      <div class="lead text-gray3">{{protectedHouseContractViewModel?.detail}}</div>
    </div>
    <div class="col-12 col-md-6 col-lg-7 mt-1 mt-md-0 btn-center">
      @for (message of protectedHouseContractViewModel?.messages; track message) {
      <p class="text-left text-mw">{{message}}</p>
      } @if (protectedHouseContractViewModel?.linkInternet) {
      <div class="d-flex justify-content-center justify-content-md-start">
        <div class="d-flex flex-column">
          <a
            class="btn btn-secondary"
            [href]="protectedHouseContractViewModel?.linkInternet | link | async"
            (click)="openProtectedHouseContract();false"
          >
            {{protectedHouseContractViewModel.button}}</a
          >
        </div>
      </div>
      }
    </div>
  </div>
</div>
